import React from 'react';

const Quote = () => (
  <div className="home">
    <br />
    <br />

    <br />
    <br />

    <p>
      Mathematicians is not about numbers, equations, computations, or algorithims:
      it is about understanding. - William Paul Thurston
    </p>
  </div>
);

export default Quote;
